module.exports = __webpack_public_path__ + "static/media/zoomy2_preview.962cd23d.jpg";